<template>
  <div class="configColorsBlock">
    <h5>
      {{ $t('design.customColors') }}
      <span style="margin-left: 4px;cursor: pointer;">
        <a-popover placement="bottom" trigger="hover">
          <template slot="content">
            {{ $t('design.customColorsTips') }}
          </template>
          <span>
            <a-icon style="color: #333" type="question-circle" />
          </span>
        </a-popover>
      </span>
    </h5>
    <div class="clearFix colorBox">
      <template v-for="(item, i) in userConfigColors">
        <div
          :style="{ background: item }"
          @click="getColor(item)"
          @contextmenu.prevent="rightClick(item)"
          class="colorItem"
          :key="i"
        ></div>
      </template>
    </div>
  </div>
</template>

<script>
import { deleteUserColors } from '@/api/design'
export default {
  name: 'ConfigColors',
  data() {
    return {
      visible: false,
      src: '',
      showMagnifier: false,
      ctx: null,
      color: ''
    }
  },
  props: ['userConfigColors', 'type'],
  methods: {
    rightClick(data) {
      const _this = this
      this.$confirm({
        title: this.$t('generic.warning'),
        content: this.$t('generic.deleteConfirm'),
        okText: this.$t('generic.yes'),
        okType: 'danger',
        cancelText: this.$t('generic.cancel'),
        onOk() {
          deleteUserColors({ user_colors: data }).then(res => {
            _this.$emit('change')
          })
        }
      })
    },
    getColor(data) {
      this.$emit(this.type === 'text' ? 'upColor' : 'upBg', data)
    }
  }
}
</script>

<style lang="less" scoped>
.configColorsBlock {
  margin-top: 10px;
  .colorBox {
    margin: 0 -5px;
    .colorItem {
      float: left;
      width: 38px;
      height: 38px;
      margin: 5px;
      border-radius: 4px;
      cursor: pointer;
    }
  }
}
</style>
